import * as React from 'react';
import { CardMedia as CardMediaMui} from '@mui/material';
import AppService from '../services/app.service';

interface Props {
  id?: string;
  url?: string;
  play?: boolean;
  autoPlay?: boolean;
  sx?: any;
  onLoad?: (data: any) => void;
  onError?: (data: any) => void;
}

export const GetType = (path: string) => {
  const [image, setImage] = React.useState<any>();
  const getTypeExt = (value: any) => {
    return value.some((d: any) => path.toLowerCase().endsWith(d));
  }

  React.useEffect(() =>  {
    AppService.checkIsImage(path).then(rp => setImage(rp))
  }, [path])

  return (
    image? 'image' :
    getTypeExt(['.mp3', '.wav', '.ogg', '.aac', '.flac'])? 'audio' : 
    getTypeExt(['.mp4', '.mov', '.avi', '.mkv', '.webm']) || path.includes('youtube')? 'video' 
    : ''
  );
}

export const Media: React.FunctionComponent<Props> = (props) => {
  const type = GetType(props.url || '');
  const mediaType = type === 'image'? 'img' : props.url?.includes('http')? 'iframe' : type;
  const isIFrame = mediaType === 'iframe';
  const isAudioVideo = ['audio', 'video'].includes(mediaType);
  const audio = new Audio();

  const play = async() => {
    var e = '';
    if (props.url && isAudioVideo) {
      audio.src = props.url;
      try {await audio.play()} catch {e = 'This media cannot be played'}
    }
    props.onError?.(e);
  }

  React.useEffect(() =>  {
    props.onLoad?.(props.url && type);
    play();
  }, [props.url, mediaType])
  
  return (
    <>
    {props.url && mediaType && type &&
    <CardMediaMui
      component={mediaType}
      src={props.url}
      allow={isIFrame? (props.autoPlay? 'autoplay' : '') + 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share' : undefined}
      allowFullScreen={isIFrame}
      alt={mediaType}
      controls={isAudioVideo}
      sx={{...props.sx}}
    />
    }
    </>
  )
}